import  { AxiosResponse } from "axios";
import axios from "../utils/axiosConfig";
import { IAddItemRequest ,IAddItemResponse, IUpdateItemRequest, IUpdateItemResponse,IGetAttributeResponse, StockTransactionPayload, IGetItemsParams, IGetItemsResponse,IGetItemsResponseList} from "../Interfaces/IInventory";
import { Item } from "../Inventory/ViewInventory";
const { BASE_URL } = require("../utils/urls");
// API URL
//const API_URL = "https://panaccoapi-453601304730.asia-south1.run.app/Inventory";
const API_URL =`${BASE_URL}/Inventory`;
//const API_URL = "http://localhost:8080/Inventory";
// Function to call the Add Item API
export const addItem = async (itemData: IAddItemRequest): Promise<IAddItemResponse> => {
  try {
    itemData.orgId=localStorage.getItem('orgId') ?? ''; 
    const response = await axios.post<IAddItemResponse>(API_URL+'/item/addItem', itemData);
    return response.data;
  } catch (error: any) {
    console.error("Error adding item:", error);
    throw new Error(error.response?.data?.message || "Failed to add item");
  }
};
export const getItems = async (orgId: string): Promise<IGetItemsResponse["items"]> => {
    try {
      const response: AxiosResponse<IGetItemsResponse> = await axios.get(`${API_URL}/item/getItems`, {
        params: { orgId },
      });
      return response.data.items;
    } catch (error: any) {
      console.error("Error fetching items:", error);
      throw new Error(error.response?.data?.message || "Failed to fetch items");
    }
  };  
export const getItemsList = async (params: IGetItemsParams): Promise<IGetItemsResponseList> => {
  const {
    orgId,
    page,
    pageSize,
    search = "",
    sortBy = "createdDate",
    sortOrder = "desc",
  } = params;

  const query = new URLSearchParams({
    orgId,
    page: String(page),
    pageSize: String(pageSize),
    search,
    sortBy,
    sortOrder,
  });

  // Replace with your existing axios call pattern (base URL, headers, etc.)
  try{
  const response = await axios.get(`${API_URL}/item/getItemsList?${query.toString()}`);
  return {
    items: response.data.items,
    totalCount: response.data.totalCount,
    page: response.data.page,
    pageSize: response.data.pageSize,
    message:response.data.message,
    success:response.data.success,
  };
  } catch (error: any) {
      console.error("Error fetching items:", error);
      throw new Error(error.response?.data?.message || "Failed to fetch items");
    }
};
// Function to update an item
export const updateItem = async ( updatedData: Partial<IAddItemRequest>): Promise<IAddItemResponse> => {
  try {
    const response = await axios.put<IAddItemResponse>(`${API_URL}/item/editItem`, updatedData);
    return response.data;
  } catch (error: any) {
    console.error("Error updating item:", error);
    throw new Error(error.response?.data?.message || "Failed to update item");
  }
};
  // Function to delete an item
  export const deleteItem = async (data: IUpdateItemRequest): Promise<IUpdateItemResponse> => {
    try {
        const response = await axios.put<IUpdateItemResponse>(`${API_URL}/item/deleteItem`,data);
        return response.data;
      
    } catch (error: any) {
      console.error("Error deleting item:", error);
      throw new Error(error.response?.data?.message || "Failed to delete item");
    }
  };
//Function to get item by itemId and OrgId
export const getItemsbyItemId = async (
  orgId: string,
  itemId: string
): Promise<Item> => {
  try {
    const response = await axios.get(`${API_URL}/item/getItemById`, {
      params: { orgId, itemId },
    });

    // Ensure the response type matches the Item interface
    return response.data.item as Item;
  } catch (error: any) {
    console.error("Error fetching items:", error);
    throw new Error(
      error.response?.data?.message || "Failed to fetch items:" + itemId
    );
  }
};
//Get Master attribute 
export const getAttribute = async (): Promise<IGetAttributeResponse[]> => {
  try {
    const response: AxiosResponse<{ items: IGetAttributeResponse[] }> = await axios.get(
      `${API_URL}/attribute/getAttribute`
    );
    return response.data.items; // Return the items array
  } catch (error: any) {
    console.error("Error fetching attributes:", error);
    throw new Error(error.response?.data?.message || "Failed to fetch attributes");
  }
};
export const getAttributeOptions = async (
  attributeId: string | number
): Promise<IGetAttributeResponse[]> => {
  try {
    const response: AxiosResponse<{ items: IGetAttributeResponse[] }> =
      await axios.get(`${API_URL}/attribute/getAttributeOptions?attributeId=${attributeId}`);
    return response.data.items || [];
  } catch (error: any) {
    console.error("Error fetching attribute options:", error);
    throw new Error(
      error.response?.data?.message || "Failed to fetch attribute options"
    );
  }
};
export const fetchCategories = async (orgId:string) => {
  try {
    const response = await axios.get(`${API_URL}/attribute/getCategory?orgId=${orgId}`);
    return response?.data?.items || []; // Assuming the response has data in the form of an array
  } catch (error) {
    console.error("Error fetching categories:", error);
  //  throw error;
  }
};
export const getBrands = async (orgId:string,categoryId:string) => {
  try {
    const response = await axios.get(`${API_URL}/attribute/getBrand?categoryId=${categoryId}&orgId=${orgId}`);
    if(response.data.success)
    {
    return response?.data?.items || [];
    }
  } catch (error) {
    console.error("Error fetching brands by category:", error);
  //  throw error;
  }
};
export const getManufacturer = async (orgId:string,brandId:string | number) => {
  try {
    const response = await axios.get(`${API_URL}/attribute/getManufacturer?brandId=${brandId}&orgId=${orgId}`);
    if(response.data.success)
    {
    return response?.data?.items || [];
    }
  } catch (error) {
    console.error("Error fetching Manufacturer by brand:", error);
    throw error;
  }
};
//
export const addBrand = async (categoryId: string,brandName:string, orgID: string, createdBy: string) => {
  try {
    
    const response = await axios.post(`${API_URL}/attribute/addBrand`, {
      categoryId,
      brandName,
      orgID,
      createdBy,
    });
    return response?.data;
  } catch (error) {
    console.error("Error adding brand:", error);
    throw error;
  }
};
export const addCategory = async (categoryName: string, orgID: string, createdBy: string) => {
  try {
  
    
    const response = await axios.post(`${API_URL}/attribute/addCategory`, {
      categoryName,
      orgID,
      createdBy,
    });

    return response.data;
  } catch (error) {
    console.error("Error adding category:", error);
    throw error;
  }
};
export const addManufacturer = async (brandId: string,manufacturerName:string, orgID: string, createdBy: string) => {
  try {
  
  const response = await axios.post(`${API_URL}/attribute/addManufacturer`, {
      brandId,
      manufacturerName,
      orgID,
      createdBy,
    });
    return response.data;
  } catch (error) {
    console.error("Error adding manufacturer:", error);
    throw error;
  }
};

/**
 * Soft deletes a category by updating its status to "inactive".
 * @param categoryId - The category ID to delete.
 * @param orgID - The organization ID.
 * @param updatedBy - The user performing the action.
 * @returns A success or error response.
 */
export const deleteCategory = async (
  categoryId: string,
  orgID: string,
  updatedBy: string
) => {
  try {
    const response = await axios.put(`${API_URL}/attribute/deleteCategory`, {
      categoryId,
      orgID,
      updatedBy,
    });

    return response.data; // Return API response
  } catch (error: any) {
    console.error("Error soft deleting category:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Failed to delete category",
    };
  }
};
export const updateBrand  = async (
  brandId: string,
  brandName:string,
  orgID: string,
  updatedBy: string
) => {
  try {
    const response = await axios.put(`${API_URL}/attribute/editBrand `, {
      brandId,
      brandName,
      orgID,
      updatedBy,
    });
    return response.data; // Return API response
  } catch (error: any) {
    console.error("Error edit in brand:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Failed to edit brand",
    };
  }
};

//Brand
export const deleteBrand = async (
  brandId : string,
  orgID: string,
  updatedBy: string
) => {
  try {
    const response = await axios.put(`${API_URL}/attribute/deleteBrand`, {
      brandId,
      orgID,
      updatedBy,
    });

    return response.data; // Return API response
  } catch (error: any) {
    console.error("Error soft deleting category:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Failed to delete category",
    };
  }
};
export const editCategory = async (
  categoryId: string,
  categoryName:string,
  orgID: string,
  updatedBy: string
) => {
  try {
    const response = await axios.put(`${API_URL}/attribute/editCategory`, {
      categoryId,
      categoryName,
      orgID,
      updatedBy,
    });

    return response.data; // Return API response
  } catch (error: any) {
    console.error("Error soft deleting category:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Failed to delete category",
    };
  }
};
// Edit Manufacturer
export const updateManufacturer = async (manufacturerId: string, manufacturerName: string, orgID: string, updatedBy: string) => {
  try {
    const response = await axios.put(`${API_URL}/attribute/editManufacturer`, { manufacturerId, manufacturerName, orgID, updatedBy });
    return response.data;
  } catch (error: any) {
    console.error("Error editing manufacturer:", error);
    return { success: false, message: error.response?.data?.message || "Failed to edit manufacturer" };
  }
};
// Soft Delete Manufacturer
export const deleteManufacturer = async (manufacturerId: string, orgID: string, updatedBy: string) => {
  try {
    const response = await axios.put(`${API_URL}/attribute/deleteManufacturer`, { manufacturerId, orgID, updatedBy });
    return response.data;
  } catch (error: any) {
    console.error("Error deleting manufacturer:", error);
    return { success: false, message: error.response?.data?.message || "Failed to delete manufacturer" };
  }
};
//Function to get item by itemId and OrgId
export const getItemsByCategory = async (
  orgId: string,
  categoryId: string
): Promise<Item[]> => {
  try {
    const response = await axios.get(`${API_URL}/item/getItemsByOrgAndCategory`, {
      params: { orgId, categoryId },
    });
    // Adjust this based on your API response structure
    return response.data.items as Item[]; // <-- Ensure this matches your backend response
  } catch (error: any) {
    console.error("Error fetching items:", error);
    throw new Error(
      error.response?.data?.message || "Failed to fetch items by category id :" + categoryId
    );
  }
};
export const getItemTransactionData = async (
  orgId: string,
  categoryId: string,
  itemId?: string,
  fromDate?: string,
  toDate?: string
) => {
  const params: any = { orgId, categoryId };
  if (itemId) params.itemId = itemId;
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  const response = await axios.get(`${API_URL}/item/getItemTransactionsDataByCatId`, { params });
  return response.data.data;
};
export const saveStockTransaction = async (payload: StockTransactionPayload) => {
  const response = await axios.post(`${API_URL}/item/addOrUpdateStockTransactionRecord`, payload);
  return response.data;
};

export const editStockTransaction = async (payload: {
  transactionId:string;
  orgId: string;
  itemId: string;
  date: string; // Format: YYYY-MM-DD
  stock: number;
  stockIn: number;
  stockOut: number;
  updatedBy: string;
  createdByIp: string;
}) => {
  const response = await axios.post(`${API_URL}/item/editStockTransactionRecord`, payload);
  return response.data;
};

export const deleteStockTransaction = async (
  orgId: string,
  itemId: string,
  transactionId: string,
  deletedBy?: string,
  deletedByIp?: string
) => {
  const payload = {
    orgId,
    itemId,
    transactionId,
    deletedBy,
    deletedByIp,
  };
  const response = await axios.post(`${API_URL}/item/deleteStockTransaction`, payload);
  return response.data;
};

export const addWarehouse = async (data: any) => {
  try {
    const response = await axios.post(`${API_URL}/attribute/addWarehouse`, data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Server error" };
  }
};

export const getWarehouses = async (orgId:string) => {
  try {
    const response = await axios.get(`${API_URL}/attribute/getWarehouses?orgId=${orgId}`);
    return response.data.warehouses || [];
  } catch (error: any) {
    throw error.response?.data || { message: "Server error" };
  }
};